import UserStatus from '../../modules/components/UserStatus';

export default UserStatus;



// WEBPACK FOOTER //
// ./src/components/shared/UserStatus.js